import { useHasPermission } from '../../hooks/useHasPermission';
import React, { useCallback, useState, useEffect } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Iconify from '../Iconify';
import '../../css/machines/MachinePageHeader.css';

const MachinePageHeader = ({ setOpenAddMachine }) => {

    const theme = useTheme();
    const { t } = useTranslation();
    const location = useLocation();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const hasMachineCreatePermission = useHasPermission('machine_create');

    const [title, setTitle] = useState(t("Machines"));

    const handleAddMachine = useCallback(() => {
        setOpenAddMachine(true);
    }, [setOpenAddMachine]);

    useEffect(() => {
        setTitle(location.pathname.includes('machines_archivees') ? 'Machines archivées' : "Machines");
    }, [location.pathname]);


    return (
        <Box className='machine_headre_main_container'>
            <Box className='machine_headre_title_box'>
                <Typography className='machine_headre_page_title'>{title}</Typography>
            </Box>
            {isDesktop && hasMachineCreatePermission &&
                <Box className='machine_headre_action_box' onClick={handleAddMachine}>
                    <Iconify className='machine_headre_add_icon' icon={"ic:baseline-plus"} />
                    <Typography className='machine_headre_action_title'>{t("addMachineButton")}</Typography>
                </Box>
            }
            {!isDesktop &&
                <Box className='machine_headre_action_box'>
                    {hasMachineCreatePermission && <Iconify className='machine_headre_add_icon' icon={"ic:baseline-plus"} onClick={handleAddMachine} />}
                </Box>
            }
        </Box>

    );
};

export default React.memo(MachinePageHeader);